import { FC, HTMLAttributes } from 'react'

export const PurpleStarIcon: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.335938" width="40" height="40" rx="20" fill="#2F3343" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4402 12.177L23.2676 15.8278C23.4467 16.1862 23.7924 16.4347 24.1933 16.4922L28.2813 17.0806C29.2913 17.2264 29.6932 18.4505 28.9623 19.1519L26.0061 21.9924C25.7156 22.2718 25.5834 22.6733 25.6521 23.0676L26.3497 27.0778C26.5215 28.0698 25.4657 28.8267 24.5629 28.3574L20.9092 26.4627C20.551 26.2768 20.122 26.2768 19.7627 26.4627L16.1089 28.3574C15.2062 28.8267 14.1503 28.0698 14.3232 27.0778L15.0198 23.0676C15.0885 22.6733 14.9563 22.2718 14.6658 21.9924L11.7096 19.1519C10.9787 18.4505 11.3806 17.2264 12.3906 17.0806L16.4786 16.4922C16.8795 16.4347 17.2262 16.1862 17.4053 15.8278L19.2317 12.177C19.6836 11.2743 20.9883 11.2743 21.4402 12.177Z"
      stroke="#A35CFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
